var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1420.56 139.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M92.78,14.6V83.887a39.946,39.946,0,0,1-5.31,20.8,34.56,34.56,0,0,1-15.344,13.7Q62.09,123.147,48.4,123.145q-20.654,0-32.08-10.584T4.89,83.594V14.6H27.521V80.152q0,12.378,4.981,18.164T48.981,104.1q11.133,0,16.15-5.822t5.017-18.275V14.6Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.209,91.944q0,14.5-10.437,22.851t-29.041,8.35q-17.137,0-30.322-6.445V95.606a124.909,124.909,0,0,0,18.347,6.811,54.261,54.261,0,0,0,13.733,1.978q7.471,0,11.463-2.857t3.991-8.5a9.379,9.379,0,0,0-1.758-5.6,19.664,19.664,0,0,0-5.163-4.725,133.264,133.264,0,0,0-13.879-7.251q-9.816-4.614-14.722-8.862a33.216,33.216,0,0,1-7.837-9.888,28.2,28.2,0,0,1-2.93-13.183q0-14.209,9.632-22.339t26.623-8.13a62.877,62.877,0,0,1,15.93,1.977A109.659,109.659,0,0,1,178.7,20.606l-7.324,17.651A107.177,107.177,0,0,0,157.2,33.35a45.667,45.667,0,0,0-11.023-1.392q-6.447,0-9.888,3a9.9,9.9,0,0,0-3.442,7.837,9.694,9.694,0,0,0,1.391,5.237,15.278,15.278,0,0,0,4.431,4.321q3.039,2.088,14.392,7.508,15.013,7.179,20.582,14.392T179.209,91.944Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.288,121.68h-61.67V14.6h61.67V33.2H218.323V56.714h36.255v18.6H218.323V102.93h38.965Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.332,80.591V121.68h-22.7V14.6h31.2q21.825,0,32.3,7.947T350.6,46.68a28.409,28.409,0,0,1-5.2,16.809A34.41,34.41,0,0,1,330.68,75.025q24.17,36.108,31.494,46.655h-25.2L311.417,80.591Zm0-18.457h7.324q10.767,0,15.894-3.589t5.127-11.279q0-7.617-5.237-10.84T306.217,33.2h-6.885Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,14.6l1.025,1.611q-3.663,14.43-12.89,35.083h-16.04q5.054-21.679,7.324-36.694Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.378,91.944q0,14.5-10.437,22.851t-29.041,8.35q-17.137,0-30.322-6.445V95.606a124.909,124.909,0,0,0,18.347,6.811,54.261,54.261,0,0,0,13.733,1.978q7.471,0,11.463-2.857t3.991-8.5a9.379,9.379,0,0,0-1.758-5.6,19.664,19.664,0,0,0-5.163-4.725,133.2,133.2,0,0,0-13.88-7.251Q412.5,70.85,407.59,66.6a33.216,33.216,0,0,1-7.837-9.888,28.2,28.2,0,0,1-2.93-13.183q0-14.209,9.632-22.339t26.623-8.13a62.883,62.883,0,0,1,15.93,1.977,109.659,109.659,0,0,1,15.857,5.567l-7.324,17.651a107.177,107.177,0,0,0-14.172-4.907,45.667,45.667,0,0,0-11.023-1.392q-6.447,0-9.888,3a9.9,9.9,0,0,0-3.442,7.837,9.694,9.694,0,0,0,1.391,5.237,15.265,15.265,0,0,0,4.431,4.321q3.039,2.088,14.392,7.508,15.013,7.179,20.581,14.392T465.378,91.944Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.4,61.548h42.481v55.518a119.6,119.6,0,0,1-19.447,4.723,126.549,126.549,0,0,1-18.639,1.356q-24.243,0-37.024-14.246T512.991,67.993q0-25.927,14.832-40.429t41.125-14.5a79.565,79.565,0,0,1,31.787,6.592l-7.544,18.164a53.867,53.867,0,0,0-24.389-5.86q-14.723,0-23.584,9.888t-8.863,26.587q0,17.431,7.141,26.624t20.765,9.191a73.408,73.408,0,0,0,14.428-1.464V80.445H558.4Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.528,14.6V83.887a39.946,39.946,0,0,1-5.31,20.8,34.555,34.555,0,0,1-15.344,13.7q-10.035,4.763-23.731,4.761-20.654,0-32.08-10.584T622.638,83.594V14.6h22.631V80.152q0,12.378,4.981,18.164t16.479,5.786q11.133,0,16.151-5.822T687.9,80.005V14.6Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.749,121.68V14.6h22.706V121.68Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.25,67.115q0,26.441-15.051,40.5T810.73,121.68H780.408V14.6h33.618q26.219,0,40.722,13.843T869.25,67.115Zm-23.584.586q0-34.5-30.468-34.5H803.113V102.93h9.741Q845.665,102.93,845.666,67.7Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.113,121.68h-61.67V14.6h61.67V33.2H911.148V56.714H947.4v18.6H911.148V102.93h38.965Z",
    style: {
      fill: "#05b758"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGuide);
export default __webpack_public_path__ + "static/media/User-Guide.4d55b9ee4341c73837ee84f287c609d6.svg";
export { ForwardRef as ReactComponent };